var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditEmailIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7660",
    d: "M3.598 18.886L16.946 5.461l-2.4-2.414L1.198 16.471l-1.17 2.914a.465.465 0 00.56.6zm14.52-14.567l1.343-1.352a1.306 1.306 0 00.112-2.028l-.5-.515a1.325 1.325 0 00-2.031.113l-1.359 1.352z",
    fill: "#838383"
  })));
}
export default SvgEditEmailIos;